import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { AgGridModule } from "@bfx/ag-grid-angular";
import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { ButtonModule } from "@bfx/primeng/button";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { DialogModule } from "@bfx/primeng/dialog";
import { OverlayPanelModule } from "@bfx/primeng/overlaypanel";
import { TranslateModule } from "@ngx-translate/core";
import { InputTextareaModule } from "@bfx/primeng/inputtextarea";

import { BfxVwapModule } from "../bfx-vwap/bfx-vwap.module";
import { BfxMenusModule } from "app/bfx-menus/bfx-menus.module";
import { BaseComponentsModule } from "shared/base-components/base-components.module";
import { BfxTradeBlotterModule } from "../bfx-blotter-trade/bfx-trade-blotter.module";

import { BfxBaseBlotterColumnSelectorService } from "../bfx-base-blotter/bfx-base-blotter-columnselector.service";
import { BfxBlotterFilterModule } from "../bfx-blotter-filter/bfx-blotter-filter.module";
import { BfxRiskTradeFilterService } from "./services/bfx-risk-trade-filter.service";
import { BfxRiskTradeBlotterComponent } from "./bfx-risk-trade-blotter.component";
import { BfxRiskTradeBlotterService } from "./services/bfx-risk-trade-blotter.service";
import { BfxRiskTradeContextMenuComponent } from "./bfx-risk-trade-contextmenu.component";
import { BfxRiskTradeContextMenuService } from "./services/bfx-risk-trade-contextmenu.service";
import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { BfxElementsLibraryModule } from "app/bfx-element-library/bfx-elements-library.module";
import { BfxInterfaceControlsModule } from "../bfx-interface-controls/bfx-interface-controls.module";

@NgModule({
  declarations: [BfxRiskTradeBlotterComponent, BfxRiskTradeContextMenuComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    AutoCompleteModule,
    CheckboxModule,
    OverlayPanelModule,
    DialogModule,
    ButtonModule,
    InputTextareaModule,
    AgGridModule.withComponents([]),
    BfxSharedModule,
    BfxBlotterFilterModule,
    BfxMenusModule,
    BaseComponentsModule,
    BfxVwapModule,
    BfxTradeBlotterModule,
    BfxElementsLibraryModule,
    BfxInterfaceControlsModule,
  ],
  exports: [BfxRiskTradeBlotterComponent, BfxRiskTradeContextMenuComponent],
  providers: [
    BfxRiskTradeBlotterService,
    BfxRiskTradeContextMenuService,
    BfxBaseBlotterColumnSelectorService,
    BfxRiskTradeFilterService,
  ],
  bootstrap: [BfxRiskTradeBlotterComponent],
})
export class BfxRiskTradeBlotterModule {}
